import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { getMe } from "./app/api";
import { useAppDispatch, useAppSelector } from "./app/hooks";
import { selectIsLoggedIn, setMe } from "./app/userSlice";
import TopicPage from "./pages/topic_page/TopicPage";
import MainPage from "./pages/main_page/MainPage";
import Header from "./components/header/Header";
import TrainingPage from "./pages/training_page/TrainingPage";

function App() {
  const isLoggedIn = useAppSelector(selectIsLoggedIn);
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    getMe().then((res) => dispatch(setMe(res)));
  }, [dispatch]);

  return (
    <BrowserRouter>
      <Header />
      <Routes>
        {isLoggedIn ? (
          <>
            <Route path="/" element={<MainPage />} />
            <Route path="/topic/:topicId/" element={<TopicPage />} />
            <Route path="/training/worst/" element={<TrainingPage />} />
          </>
        ) : (
          <Route
            path="*"
            element={<h1 style={{ textAlign: "center" }}>Please log in</h1>}
          />
        )}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
